import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import * as _ from "lodash";
import { CommonService } from "../../../services/common.service";

@Component({
  selector: "app-editar-profesional",
  templateUrl: "./editar-profesional.component.html",
  styleUrls: ["./editar-profesional.component.scss"],
  providers: [CommonService],
})
export class EditarProfesionalComponent implements OnInit {
  private id;
  public profesional;
  public especialidadesProfesional: any[];
  public osProfesional: any[];
  public turnosProfesional: any[];
  public licenciasProfesional: any[];

  public especialidades: any[];
  public obras: any[];
  public centros: any[];
  public dias: any[];
  public horarios: any[];
  public turno: any;
  public licencia: any;

  public loadingEsp: boolean;
  public loadingOs: boolean;
  public loadingTurnos: boolean;
  public loadingLicencias: boolean;

  public showEspecialidades = false;
  public showOs = false;
  public showTurnos = false;
  public showLicencias = false;

  public es: any;

  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private lo: Location
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params["id"]) {
        this.id = params["id"];
      }
    });

    this.es = {
      firstDayOfWeek: 0,
      dayNames: [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ],
      monthNamesShort: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic",
      ],
    };

    if (this.id) {
      Promise.all([
        this.commonService.getProfesional(this.id),
        this.commonService.getEspecialiadesProfesional(this.id),
        this.commonService.getOSProfesional(this.id),
        this.commonService.getTurnosProfesional(this.id),
        this.commonService.getLicenciasProfesional(this.id),
        this.commonService.getEspecialiades(),
        this.commonService.getOS(),
        this.commonService.getCentros(),
        this.commonService.getDias(),
        this.commonService.getHorarios(),
      ]).then((result) => {
        this.profesional = result[0][0];

        if (!this.profesional) {
          alert("No exite el profesional");
          this.lo.back();
        } else {
          this.especialidadesProfesional = result[1];
          this.osProfesional = result[2];
          this.turnosProfesional = result[3];
          this.licenciasProfesional = result[4];
          this.especialidades = result[5];
          this.obras = result[6];
          this.centros = result[7];
          this.dias = result[8];
          this.horarios = result[9];

          this.turno = {
            dias_id: 0,
            horarios_id: 0,
            centros_de_salud_id: 0,
            profesionales_id: this.profesional.id,
          };

          this.licencia = {
            desde: new Date(),
            hasta: new Date(),
            profesionales_id: this.profesional.id,
          };
        }
      });
    }
  }

  public add(c) {
    this.resetShows();

    if (c === "especialidades") {
      this.checkEspecialidades();
      this.showEspecialidades = true;
    } else if (c === "os") {
      this.checkOs();
      this.showOs = true;
    } else if (c === "turnos") {
      this.showTurnos = true;
    } else if (c === "licencias") {
      this.showLicencias = true;
    }
  }

  private resetShows() {
    this.showEspecialidades = false;
    this.showOs = false;
    this.showTurnos = false;
    this.showLicencias = false;
    this.turno = {
      dias_id: 0,
      horarios_id: 0,
      centros_de_salud_id: 0,
      profesionales_id: this.profesional.id,
    };
    this.licencia = {
      desde: new Date(),
      hasata: new Date(),
      profesionales_id: this.profesional.id,
    };
  }

  private checkEspecialidades() {
    this.especialidades.map((esp) => {
      esp.checked = esp.checked
        ? esp.checked
        : _.some(this.especialidadesProfesional, esp);
      esp.disabled = esp.checked;
    });
  }

  private checkOs() {
    this.obras.map((os) => {
      os.checked = os.checked ? os.checked : _.some(this.osProfesional, os);
      os.disabled = os.checked;
    });
  }

  public checkFederacion() {
    this.obras.forEach((os) => {
      if (os.federacion === "1" && !os.disabled) {
        os.checked = !os.checked;
      }
    });
  }

  public checkHasta() {
    if (this.licencia.hasta < this.licencia.desde) {
      this.licencia.hasta = this.licencia.desde;
    }
  }

  public saveEspecialidades() {
    var c = 0;
    var espToSave = _.filter(this.especialidades, (e) => {
      return e.checked && !e.disabled;
    });

    espToSave.forEach((e) => {
      this.commonService
        .saveEspecialidadXProfesional(this.profesional.id, e.id)
        .then(() => {
          c++;

          if (c === espToSave.length) {
            this.commonService
              .getEspecialiadesProfesional(this.profesional.id)
              .then((result) => {
                this.especialidadesProfesional = result;
                this.resetShows();
              });
          }
        });
    });
  }

  public saveObras() {
    var c = 0;
    var osToSave = _.filter(this.obras, (o) => {
      return o.checked && !o.disabled;
    });

    osToSave.forEach((o) => {
      this.commonService
        .saveOsXProfesional(this.profesional.id, o.id)
        .then(() => {
          c++;

          if (c === osToSave.length) {
            this.commonService
              .getOSProfesional(this.profesional.id)
              .then((result) => {
                this.osProfesional = result;
                this.resetShows();
              });
          }
        });
    });
  }

  public saveTurno() {
    this.commonService.saveTurnoProfesional(this.turno).then(() => {
      this.commonService
        .getTurnosProfesional(this.profesional.id)
        .then((result) => {
          this.turnosProfesional = result;
          this.resetShows();
        });
    });
  }

  public saveLicencia() {
    this.commonService.saveLicenciaProfesional(this.licencia).then(() => {
      this.commonService
        .getLicenciasProfesional(this.profesional.id)
        .then((result) => {
          this.licenciasProfesional = result;
          this.resetShows();
        });
    });
  }

  public removeTurno(idTurno) {
    this.commonService.bajaTurnoProfesional(idTurno).then(() => {
      this.commonService
        .getTurnosProfesional(this.profesional.id)
        .then((result) => {
          this.turnosProfesional = result;
          this.resetShows();
        });
    });
  }

  public removeLicencia(idLicencia) {
    this.commonService.removeLicencia(idLicencia).then(() => {
      this.commonService
        .getLicenciasProfesional(this.profesional.id)
        .then((result) => {
          this.licenciasProfesional = result;
          this.resetShows();
        });
    });
  }

  public cancelEditing() {
    this.resetShows();
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/carga/profesionales/editar-profesional/editar-profesional.component.ts